import React from "react";
import PropTypes from "prop-types";
import ContractDurationItem from "./ContractDurationItem";
import { PromotionStyle } from "./ContractDurationStyle";
import FilterItems from "../filterItems/FilterItems";
const ContractDuration = (props) => {
	return (
		<>
			<div className="customFilter d-none d-lg-block">
			{props?.contractdurationList && props?.contractdurationList.length >0 &&(<p className="filter-heading">Contract duration</p>)}				{props?.contractdurationList?.map((item, index) => (
					<ContractDurationItem key={`contact-duration-${item.id}-${index}`} contractduration={item}
					filteredContractDuration={(props.filteredContractDuration) ? props.filteredContractDuration: []}
					contractdurationClickHandler={(flag) => props.handleContratcDurationSelect(flag, item)}/>
				))}
			</div>
			<FilterItems heading="Contract duration" handleClick={props.ContractDuration}
			id={props?.displayContractDuration == true && props?.filteredContractDuration?.length ? `filtered_brands_${props?.filteredContractDuration}` : null}
			renderFun={ props?.filteredContractDuration?.map(brand => brand.label).join(", ")}
			/>
			<style jsx>{PromotionStyle}</style>
		</>
	);
};

ContractDuration.propTypes = {
	promotions: PropTypes.array,
	promo: PropTypes.func,
	filteredPromotions: PropTypes.string,
	handlePromotionSelect: PropTypes.func,
	contractdurationList: PropTypes.array,
	filteredContractDuration: PropTypes.array,
	handleContratcDurationSelect: PropTypes.func,
	ContractDuration: PropTypes.any,
	displayContractDuration: PropTypes.bool,
};

export default ContractDuration;
